import { dataHooks } from '@wix/data-hooks';

export const AnswerFeedbackDataHooks = dataHooks<{
  feedbackSection;
  thumbUpButton;
  thumbDownButton;
  reasonsSection;
  reasonsSectionCloseButton;
  reasonButton: { id: string };
  otherReasonInputArea;
  otherReasonModalSendButton;
  otherReasonModalCancelButton;
}>('AnswerFeedback');
